import React from 'react'
import * as UniversalRouter from 'universal-router'
import { SurveyResultsConnected } from './component'
import { SurveyResultsRedirect } from './redirect_component'

export const routes = [
  {
    action: (context?: UniversalRouter.ActionContext) =>
      <SurveyResultsRedirect 
        key="survey_results_redirect" 
        communityIdentifier={context?.params?.community_identifier} 
      />,
    path: '/survey_results/:community_identifier',
  },
  {
    action: (context?: UniversalRouter.ActionContext) =>
      <SurveyResultsConnected key="survey_results_view" />,
    path: '/survey_results_view/:community_identifier',
  },
]